import React from "react";

//STYLES
import * as ControllerStyles from "../styles/controller";

function GrowMenuItem(props) {
    function handleOnEnter() {
        console.log(props.title);
    }

    return (
        <div style={ControllerStyles.menu_GrowMenuItem} onMouseEnter={handleOnEnter}>
            {props.title}
        </div>
    );
}

export default GrowMenuItem;
